import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const { handleAuthResponse } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // CRITICAL: Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          throw new Error('No session_id found');
        }

        // Exchange session_id for user session
        const response = await axios.post(
          `${API_URL}/api/auth/google-session?session_id=${sessionId}`,
          {},
          { withCredentials: true }
        );

        const userData = response.data.user;
        handleAuthResponse(response.data);

        // Redirect based on role
        const dashboardPath = getDashboardPath(userData.role);
        navigate(dashboardPath, { replace: true, state: { user: userData } });
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login', { replace: true });
      }
    };

    processSession();
  }, [navigate, handleAuthResponse]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-navy">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-gold border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-white text-lg">Completing sign in...</p>
      </div>
    </div>
  );
};

function getDashboardPath(role) {
  if (role === 'super_admin' || role === 'league_admin') {
    return '/admin/dashboard';
  } else {
    return '/dashboard';
  }
}

export default AuthCallback;